import React from 'react';
import { ReactComponent as CustomFontIcon } from 'qs-assets/Media/ic_custom_font_icon.svg';
import './styles.scss';

export default ({ width, height, fill, classes = '' }) => {
  return (
    <CustomFontIcon
      style={{ width, height, fill }}
      className={`settingsIconComponent ${classes}`}
    />
  );
};
